export const GET_SPATIAL_VIEW = 'GET_SPATIAL_VIEW';
export const GET_SPATIAL_VIEW_SUCCESS = 'GET_SPATIAL_VIEW_SUCCESS';
export const GET_SPATIAL_VIEW_FAILURE = 'GET_SPATIAL_VIEW_FAILURE';
export const SET_ADD_SPATIAL_VIEW_OPEN = 'SET_ADD_SPATIAL_VIEW_OPEN';
export const CREATE_SPATIAL_VIEW = 'CREATE_SPATIAL_VIEW';
export const CREATE_SPATIAL_VIEW_SUCCESS = 'CREATE_SPATIAL_VIEW_SUCCESS';
export const CREATE_SPATIAL_VIEW_FAILURE = 'CREATE_SPATIAL_VIEW_FAILURE';
export const UPLOAD_FILE_TO_S3 = 'UPLOAD_FILE_TO_S3';
export const UPLOAD_FILE_TO_S3_SUCCESS = 'UPLOAD_FILE_TO_S3_SUCCESS';
export const UPLOAD_FILE_TO_S3_FAILURE = 'UPLOAD_FILE_TO_S3_FAILURE';
export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS';
export const SET_EDIT_SPATIAL_VIEW_OPEN = 'SET_EDIT_SPATIAL_VIEW_OPEN';
export const UPDATE_SPATIAL_VIEW = 'UPDATE_SPATIAL_VIEW';
export const UPDATE_SPATIAL_VIEW_SUCCESS = 'UPDATE_SPATIAL_VIEW_SUCCESS';
export const UPDATE_SPATIAL_VIEW_FAILURE = 'UPDATE_SPATIAL_VIEW_FAILURE';
export const DELETE_SPATIAL_VIEW = 'DELETE_SPATIAL_VIEW';
export const DELETE_SPATIAL_VIEW_SUCCESS = 'DELETE_SPATIAL_VIEW_SUCCESS';
export const DELETE_SPATIAL_VIEW_FAILURE = 'DELETE_SPATIAL_VIEW_FAILURE';
export const FETCH_GLB_URL = 'FETCH_GLB_URL';
export const FETCH_GLB_URL_SUCCESS = 'FETCH_GLB_URL_SUCCESS';
export const FETCH_GLB_URL_FAILURE = 'FETCH_GLB_URL_FAILURE';
export const UPDATE_MODEL = 'UPDATE_MODEL';
export const UPDATE_MODEL_SUCCESS = 'UPDATE_MODEL_SUCCESS';
export const UPDATE_MODEL_FAILURE = 'UPDATE_MODEL_FAILURE';
export const FETCH_SENSOR_DEVICES = 'FETCH_SENSOR_DEVICES';
export const FETCH_SENSOR_DEVICES_SUCCESS = 'FETCH_SENSOR_DEVICES_SUCCESS';
export const FETCH_SENSOR_DEVICES_FAILURE = 'FETCH_SENSOR_DEVICES_FAILURE';
export const FETCH_TATAM_DEVICES = 'FETCH_TATAM_DEVICES';
export const FETCH_TATAM_DEVICES_SUCCESS = 'FETCH_TATAM_DEVICES_SUCCESS';
export const FETCH_TATAM_DEVICES_FAILURE = 'FETCH_TATAM_DEVICES_FAILURE';
export const INSTALL_SPATIAL_VIEW_DEVICE = 'INSTALL_SPATIAL_VIEW_DEVICE';
export const INSTALL_SPATIAL_VIEW_DEVICE_SUCCESS = 'INSTALL_SPATIAL_VIEW_DEVICE_SUCCESS';
export const INSTALL_SPATIAL_VIEW_DEVICE_FAILURE = 'INSTALL_SPATIAL_VIEW_DEVICE_FAILURE';
export const UNINSTALL_SPATIAL_VIEW_DEVICE = 'UNINSTALL_SPATIAL_VIEW_DEVICE';
export const UNINSTALL_SPATIAL_VIEW_DEVICE_SUCCESS = 'UNINSTALL_SPATIAL_VIEW_DEVICE_SUCCESS';
export const UNINSTALL_SPATIAL_VIEW_DEVICE_FAILURE = 'UNINSTALL_SPATIAL_VIEW_DEVICE_FAILURE';
export const FETCH_TOTAL_DEVICES = 'FETCH_TOTAL_DEVICES';
export const FETCH_TOTAL_DEVICES_SUCCESS = 'FETCH_TOTAL_DEVICES_SUCCESS';
export const FETCH_TOTAL_DEVICES_FAILURE = 'FETCH_TOTAL_DEVICES_FAILURE';
export const START_GLB_PROCESSING = 'START_GLB_PROCESSING';
export const FETCH_LIVE_POLLING = 'FETCH_LIVE_POLLING';
export const FETCH_LIVE_POLLING_SUCCESS = 'FETCH_LIVE_POLLING_SUCCESS';
export const FETCH_LIVE_POLLING_FAILURE = 'FETCH_LIVE_POLLING_FAILURE';
export const STOP_LIVE_POLLING = 'STOP_LIVE_POLLING';
export const FETCH_SPATIAL_VIEW_OPERATIONS = 'FETCH_SPATIAL_VIEW_OPERATIONS';
export const FETCH_SPATIAL_VIEW_OPERATIONS_SUCCESS = 'FETCH_SPATIAL_VIEW_OPERATIONS_SUCCESS';
export const FETCH_SPATIAL_VIEW_OPERATIONS_FAILURE = 'FETCH_SPATIAL_VIEW_OPERATIONS_FAILURE';